import {
  ActivityIndicator,
  View,
} from 'react-native';

import * as rcl from "./_csRcl";
import * as cr from "./_cr";
import * as cv from "./_cv";

import { a } from "./_csAbt";

import * as TextC from "./_ccbTextC";

const _ldrz = rcl.grtAtom('ldrz', {
  bShow: false,
});

export const useLdrz = () => {
  const _dz = rcl.grtStt(_ldrz);
  const _show = () => {
    _dz.set({
      bShow: true
    })
  };
  const _hide = () => {
    _dz.set({
      bShow: false
    })
  };
  return {
    ... _dz,
    show: _show,
    hide: _hide,
  }
};

export const N = () => {
  const _sLdrz = useLdrz();
  if ( _sLdrz?.crt?.bShow != true) return null;
  return (
    cr.c(View, {
      key: 'Ldr.root',
      style: { // backgroundColor で rgba を指定しない（StatusBarと色が異なってしまうため）
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: cv.zIdxLdr,
        top: 0,
        left: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
    }, [ 

      cr.c(TextC.N, {
        key: -10,
        textz: {
          pfx: '処理中のため、ブラウザを閉じないで下さい',
          stlz: {
            ... a('tb tc/lt1'),
          },
          ptyz: {
            ... a("tn/10"),
          },
        },
        boxStlz: {
          ... a("fd/ccc fw/w sc/rd5 p/2"),
        },
      }),

      cr.c(ActivityIndicator, {
        key: -20,
        animating: true,
        color: '#C0C0C0',
        size: 100
      }),
    ])
  )

};
